// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff7eae14","879":"0c2ccf7f"}[chunkId] + ".chunk.js";
};